// Debug utility para verificar la configuración del entorno
export const debugEnvironmentConfig = () => {
  console.log("🔧 Environment Configuration Debug:", {
    // Variables de entorno
    VITE_APP_API_ENDPOINT: import.meta.env.VITE_APP_API_ENDPOINT,
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
    PROD: import.meta.env.PROD,

    // Información del navegador
    hostname: window.location.hostname,
    origin: window.location.origin,
    pathname: window.location.pathname,
    search: window.location.search,

    // Información del usuario
    userAgent: navigator.userAgent,
    language: navigator.language,

    // Información de la aplicación
    timestamp: new Date().toISOString(),
  })
}

// Función para verificar si estamos en producción
export const isProduction = () => {
  return import.meta.env.PROD || window.location.hostname.includes("motivy.co")
}

import { isOutpoints } from "@/utils"

// Re-export isOutpoints para compatibilidad
export { isOutpoints }

// Función para verificar la configuración de la API
export const debugApiConfig = () => {
  console.log("🌐 API Configuration Debug:", {
    baseURL: import.meta.env.VITE_APP_API_ENDPOINT,
    isProduction: isProduction(),
    isOutpoints: isOutpoints(),
    hostname: window.location.hostname,
  })
}
